<template>
  <div class="card">
    <header class="header-card">
      <p>{{ $t('detailDemandeImpression.dispositif.title')}}</p>
    </header>
    <div class="card-content">
      <div class="columns" v-if="demandeImpression.dispositif && finMounted">
        <div class="column is-6">
          <div class="columns is-multiline">
            <b-field :label="$t('detailDemandeImpression.dispositif.title')"
              custom-class="has-text-weight-normal is-italic is-marginless"
              class="column is-12 is-marginless">
              <span class="has-text-weight-bold">
                <router-link-blank
                  v-if="demandeImpression.dispositifId"
                  :to="{
                    name: 'c.gabed.emplacement-detailDispositif',
                    params: {
                      idDispositif: demandeImpression.dispositifId,
                    }
                  }"
                  class="lien"
                  :message="demandeImpression.dispositif.code"/>
              </span>
            </b-field>
            <b-field :label="$t('detailDemandeImpression.dispositif.typeDispositif')"
              custom-class="has-text-weight-normal is-italic is-marginless"
              class="column is-12 is-marginless">
              <span class="has-text-weight-bold">
                {{ dipositifTypeLibelle }}
              </span>
            </b-field>
            <b-field :label="$t('detailDemandeImpression.dispositif.typeMateriel')"
              custom-class="has-text-weight-normal is-italic is-marginless"
              class="column is-12 is-marginless">
              <span class="has-text-weight-bold">
                {{ materielTypeLibelle }}
              </span>
            </b-field>
          </div>
        </div>
        <div class="column is-6 has-text-weight-bold">
          <p class="has-text-weight-normal is-italic is-size-6 mgb-10px">
            {{ $t('detailDemandeImpression.dispositif.adresse') }}
          </p>
          <adresse-detail class="mgl-1"
            :adresse="demandeImpression.dispositif.adresse">
          </adresse-detail>
        </div>
      </div>
      <div v-else class="has-text-centered title">
        {{  $t('detailDemandeImpression.dispositif.aucunDispositif') }}
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import RouterLinkBlank from '@/components/general/routerLinkBlank';
import adresseDetail from '@/components/general/adresseDetail';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { getTypeMaterielLibelle } from '@/services/gabed/dispositif/dispositifService';

const Parametres = createNamespacedHelpers('parametres');
export default {
  data() {
    return {
      finMounted: false,
    };
  },
  props: {
    demandeImpression: {
      type: Object,
      required: true,
    },
  },
  components: {
    RouterLinkBlank,
    adresseDetail,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    dispositifType() {
      return this.parametre(PARAMETRES_KEYS.dispositifType);
    },
    materielType() {
      return this.parametre(PARAMETRES_KEYS.materielType);
    },
    dipositifTypeLibelle() {
      return this.dispositifType.find(t => t.id
        === this.demandeImpression.dispositif?.dispositifTypeId)?.libelle ?? '';
    },
    materielTypeLibelle() {
      return getTypeMaterielLibelle(
        this.demandeImpression.dispositif?.materiels,
        this.materielType,
      );
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
  },
  async mounted() {
    await this.loadParametres([
      PARAMETRES_KEYS.dispositifType,
      PARAMETRES_KEYS.materielType,
    ]);
    this.finMounted = true;
  },
};
</script>

<style>

</style>
